export const FETCH_SITE_SETTINGS_SUCCESS =
  'cboard/App/FETCH_SITE_SETTINGS_SUCCESS';
export const UPDATE_SITE_SETTINGS_SUCCESS =
  'cboard/App/UPDATE_SITE_SETTINGS_SUCCESS';
